// VH-67: Renders a HealthReport detail.
// - If findings.weeks is present → new picker layout (PerWeekColumns / RangeTotals / AiNarrative).
// - Otherwise (legacy rows) → falls through to the existing WeeklyReportView (regression guard).
import { useTranslation } from 'react-i18next'
import WeeklyReportView from './WeeklyReportView'
import PerWeekColumns from './PerWeekColumns'
import RangeTotalsCard from './RangeTotalsCard'
import AiNarrative from './AiNarrative'

export default function HealthReportView({ report }) {
  const { t, i18n } = useTranslation()

  if (!report) return null

  const findings = report.findings || {}
  const weeks = findings.weeks
  const hasWeeks = weeks && typeof weeks === 'object' && Object.keys(weeks).length > 0

  // Legacy WEEKLY_ACHIEVEMENT row (no findings.weeks key) → existing view.
  if (!hasWeeks) {
    return <WeeklyReportView report={report} />
  }

  const weekCount = Object.keys(weeks).length
  const locale = i18n.language === 'de' ? 'de-DE' : i18n.language === 'pt-BR' ? 'pt-BR' : 'en-US'
  const createdAt = report.created_at ? new Date(report.created_at).toLocaleDateString(locale) : ''

  return (
    <div className="space-y-6">
      <div className="text-center pb-2 border-b">
        <h2 className="text-2xl font-bold text-gray-900">{t('reports.picker.title')}</h2>
        {createdAt && <p className="text-sm text-gray-500 mt-1">{createdAt}</p>}
      </div>

      <AiNarrative
        reportId={report.id}
        narrative={findings.ai_narrative}
        unavailable={!!findings.ai_unavailable}
      />

      <RangeTotalsCard totals={findings.range_totals} weekCount={weekCount} />

      <PerWeekColumns weeks={weeks} />
    </div>
  )
}
